import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./styles/app.scss";
import { LoginMicrosoft } from "./components/login-microsoft";
import Home from "./components/home";
import Quiz from "./components/quiz";
import { LoginEmail } from "./components/login-email";
import { LoginPassword } from "./components/login-password";
import { useEffect, useState } from "react";
import {
  changeUserLanguageRealtime,
  getCompanyInfoDB,
  getQuestionsDataDB,
  getUserInfoDB,
  getUserLanguageRealtime,
  getUserProfileDB,
} from "./lib/db";
import { es } from "./lib/constants";
import { useMediaQuery } from 'react-responsive';

function App() {
  const loginType = process.env.REACT_APP_LOGIN_TYPE;
  const [language, setLanguage] = useState(es);
  const [questionsData, setQuestionsData] = useState();
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [userProfile, setUserProfile] = useState();
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });

  useEffect(() => {
    let userSession = JSON.parse(sessionStorage.getItem("user_IRT"));
    if (userSession) {
      getUserInfoDB(userSession.userID).then((data) => {
        setUser(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      getUserProfileDB(user.id).then((data) => {
        if (Object.values(data).length > 0) {
          setUserProfile(data);
        }
      });
      getUserLanguageRealtime(user.id).then((userLanguage) => {
        if (userLanguage === null) {
          userLanguage = language;
        }
        changeLanguage(user.id, userLanguage);
      });
      getQuestionsDataDB(language).then((data) => {
        setQuestionsData(data);
      });
      getCompanyInfoDB(user.company).then((data) => {
        setCompany(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, language]);

  const changeLanguage = async (userID, lang) => {
    setLanguage(lang);
    if (userID) {
      await changeUserLanguageRealtime(userID, lang);
    }
  };

  const loginComponents = {
    microsoft: (
      <LoginMicrosoft
        language={language}
        changeLanguage={changeLanguage}
        user={user}
        setUser={setUser}
        isDesktop={isDesktop}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    ),
    email: (
      <LoginEmail
        language={language}
        changeLanguage={changeLanguage}
        user={user}
        setUser={setUser}
        isDesktop={isDesktop}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    ),
    password: (
      <LoginPassword
        language={language}
        changeLanguage={changeLanguage}
        user={user}
        setUser={setUser}
        isDesktop={isDesktop}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    ),
  };

  return (
    <div>
      {loginType && (
        <BrowserRouter>
          <Routes>
            <Route index element={loginComponents[loginType]} />
            <Route path="/" element={loginComponents[loginType]} />
            <Route path="/login" element={loginComponents[loginType]} />
            <Route
              path="/home"
              element={
                <Home
                  user={user}
                  setUser={setUser}
                  userProfile={userProfile}
                  setUserProfile={setUserProfile}
                  company={company}
                  changeLanguage={changeLanguage}
                  language={language}
                  isMobile={isMobile}
                  isTablet={isTablet}
                  isDesktop={isDesktop}
                />
              }
            />
            <Route
              path="/quiz"
              element={
                <Quiz
                  user={user}
                  setUser={setUser}
                  userProfile={userProfile}
                  setUserProfile={setUserProfile}
                  company={company}
                  changeLanguage={changeLanguage}
                  language={language}
                  questionsData={questionsData}
                  isMobile={isMobile}
                  isTablet={isTablet}
                  isDesktop={isDesktop}
                />
              }
            />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
